import { LoadingButton } from '@mui/lab'
import { Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'

import { useGetAccountPayableRemittanceQuery } from 'generated/graphql'

import PaperPanel from '../PaperPanel'

const RemittancePanel = () => {
  const { id } = useParams<{ id?: string }>()

  const { data: remittance, loading } = useGetAccountPayableRemittanceQuery({
    fetchPolicy: 'network-only',
    variables: { accountPayableRecordId: Number(id) },
  })

  if (loading) {
    return <LoadingButton loading={loading} />
  }

  return (
    <Stack spacing={2} alignItems={'center'}>
      <Typography variant='h6'>Remittance Advice</Typography>
      <PaperPanel>
        <div
          dangerouslySetInnerHTML={{
            __html: remittance?.accountPayableRemittance.htmlString ?? '',
          }}></div>
      </PaperPanel>
    </Stack>
  )
}

export default RemittancePanel